/* KUSTM small site script */
(function () {
  'use strict';

  // ---- smooth scroll for anchor links ----
  document.addEventListener('click', (e) => {
    const a = e.target.closest('a[href^="#"]');
    if (!a) return;
    const id = a.getAttribute('href').slice(1);
    if (!id) return;
    const target = document.getElementById(id);
    if (target) {
      e.preventDefault();
      target.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  });

  // ---- cart: garment lines own their print-fee line (linked by _design_id) ----
  const form = document.querySelector('[data-kustm-cart-form]');
  if (!form) return;

  const feeVariant = Number(form.dataset.feeVariant || 0);
  const feeUnit = Number(form.dataset.feeUnit || 100);
  const lineEls = Array.from(form.querySelectorAll('[data-kustm-line]'));

  function feeQtyFor(lineEl, qty) {
    const per = Number(lineEl.dataset.feePerUnit || 0);
    return Math.round((per * 100) / feeUnit) * qty;
  }

  async function post(url, body) {
    const res = await fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body),
    });
    if (!res.ok) throw new Error(url + ' ' + res.status);
    return res.json();
  }

  function busy(on) { form.classList.toggle('is-busy', !!on); }

  async function setLineQty(lineEl, qty) {
    qty = Math.max(0, Math.min(500, qty | 0));
    const updates = {};
    updates[lineEl.dataset.key] = qty;
    if (lineEl.dataset.feeKey) updates[lineEl.dataset.feeKey] = feeQtyFor(lineEl, qty);
    busy(true);
    try { await post('/cart/update.js', { updates }); }
    catch (err) { console.error('[kustm-cart]', err); }
    window.location.reload();
  }

  form.addEventListener('click', (e) => {
    const lineEl = e.target.closest('[data-kustm-line]');
    if (!lineEl) return;
    if (e.target.closest('[data-kustm-remove]')) { e.preventDefault(); setLineQty(lineEl, 0); return; }
    const dec = e.target.closest('[data-kustm-qty-dec]');
    const inc = e.target.closest('[data-kustm-qty-inc]');
    if (!dec && !inc) return;
    e.preventDefault();
    const input = lineEl.querySelector('[data-kustm-qty-input]');
    const cur = parseInt(input.value, 10) || 0;
    const next = dec ? Math.max(0, cur - 1) : cur + 1;
    input.value = next;
    setLineQty(lineEl, next);
  });

  let typeTimer;
  form.addEventListener('input', (e) => {
    const input = e.target.closest('[data-kustm-qty-input]');
    if (!input) return;
    const lineEl = input.closest('[data-kustm-line]');
    const feeInput = lineEl.querySelector('[data-kustm-fee-input]');
    const q = Math.max(0, parseInt(input.value, 10) || 0);
    if (feeInput) feeInput.value = feeQtyFor(lineEl, q); // keeps a direct checkout submit consistent
    clearTimeout(typeTimer);
    typeTimer = setTimeout(() => setLineQty(lineEl, q), 700);
  });

  // ---- reconcile: fee qty must equal per-unit fee x garment qty; no orphan fees ----
  (async function reconcile() {
    const guardKey = 'kustm-reconcile-at';
    try {
      const last = Number(sessionStorage.getItem(guardKey) || 0);
      if (Date.now() - last < 8000) return; // never loop
    } catch (_) {}
    const updates = {};
    const adds = [];
    lineEls.forEach((el) => {
      const qty = Number(el.dataset.qty || 0);
      const expected = feeQtyFor(el, qty);
      if (el.dataset.feeKey) {
        if (Number(el.dataset.feeQty) !== expected) updates[el.dataset.feeKey] = expected;
      } else if (expected > 0 && feeVariant && el.dataset.designId) {
        adds.push({ id: feeVariant, quantity: expected, properties: { _design_id: el.dataset.designId, For: el.dataset.title || '' } });
      }
    });
    form.querySelectorAll('[data-kustm-fee]').forEach((el) => { updates[el.dataset.key] = 0; });
    if (!Object.keys(updates).length && !adds.length) return;
    try { sessionStorage.setItem(guardKey, String(Date.now())); } catch (_) {}
    busy(true);
    try {
      if (Object.keys(updates).length) await post('/cart/update.js', { updates });
      if (adds.length) await post('/cart/add.js', { items: adds });
    } catch (err) { console.error('[kustm-cart] reconcile', err); }
    window.location.reload();
  })();
})();
